// extracted by mini-css-extract-plugin
export default {"Zenus_Bank_Turquoise_Primary_RGB":"Logo_Zenus_Bank_Turquoise_Primary_RGB__prmap"};